import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from '../password-reset/password-reset.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [LoginComponent, PasswordResetComponent],
})
export class AuthModule {
}
